import { Dispatch } from "react";
import { QrCodeActions } from "@swiggy-private/portal-dineout-context";
import type { IQrCodeAction } from "@swiggy-private/portal-dineout-context";

// Helper function to dispatch the appropriate action based on context
export const dispatchFilterAction = (params: {
    dispatch: Dispatch<IQrCodeAction>;
    isCollectionsContext: boolean;
    collectionId?: string;
    actionType: "PARENT_TYPE" | "CATEGORY" | "PREFERENCE";
    payload: Record<string, unknown>;
}) => {
    const { dispatch, isCollectionsContext, collectionId, actionType, payload } = params;

    if (isCollectionsContext) {
        if (!collectionId) {
            throw new Error("collectionId is required when context is collections");
        }

        switch (actionType) {
            case "PARENT_TYPE":
                dispatch({
                    type: QrCodeActions.UPDATE_COLLECTIONS_BY_PARENT_TYPE,
                    payload: { collectionId, ...payload },
                });
                break;
            case "CATEGORY":
                dispatch({
                    type: QrCodeActions.UPDATE_COLLECTIONS_FILTER_DATA,
                    payload: { collectionId, data: payload.filteredData },
                });
                break;
            case "PREFERENCE":
                dispatch({
                    type: QrCodeActions.UPDATE_COLLECTIONS_PREFERENCE,
                    payload: { collectionId, ...payload },
                });
                break;
            default:
                throw new Error(`Unknown action type: ${actionType}`);
        }
    } else {
        switch (actionType) {
            case "PARENT_TYPE":
                dispatch({ type: QrCodeActions.UPDATE_DATA_BY_PARENT_TYPE, payload });
                break;
            case "CATEGORY":
                dispatch({ type: QrCodeActions.UPDATE_DATA_BY_CATEGORY, payload });
                break;
            case "PREFERENCE":
                dispatch({ type: QrCodeActions.UPDATE_DATA_PREFERENCE, payload });
                break;
            default:
                throw new Error(`Unknown action type: ${actionType}`);
        }
    }
};
